import { Header } from "../../../components/layout/header";
import { Main } from "../../../components/layout/main";
import { LogOut, Loader2 } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { useAuthStore } from "../../../stores/auth";
import { DatePicker } from "../../../components/ui/date-picker";
import CreateDayOff from "./components/create-day-off";
import useDayOff from "../../../hooks/day-off";
import { Input } from "../../../components/ui/input";
import DayOffItem from "./components/day-off-item";

const DayOff: React.FC = () => {
    const { logout } = useAuthStore();
    const { query, setQuery, data, isLoading } = useDayOff();

    const handleDateChange = (key: 'startDate' | 'endDate') => (date: Date | undefined) => {
        setQuery({
            ...query,
            [key]: date?.toISOString()
        });
    };

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setQuery({
            ...query,
            search: e.target.value
        });
    };
    return (
        <>
            <Header fixed className='flex justify-between w-[inherit]'>
                <div className='mr-0 flex items-center justify-end space-x-4 w-[inherit]'>
                    <Button variant="outline" size="icon" onClick={logout}>
                        <LogOut />
                    </Button>
                </div>
            </Header>
            <Main>
                <h4 className="text-2xl font-bold">Day Off</h4>
                <div className="flex justify-between gap-4 mt-4 relative z-99">
                    <div className="flex gap-2 flex-wrap">
                        <Input
                            placeholder="Search"
                            value={query.search}
                            onChange={handleSearch}
                            className="w-[70ppx]"
                        />
                        <DatePicker
                            label="Start Date"
                            date={query.startDate ? new Date(query.startDate) : undefined}
                            onChange={handleDateChange('startDate')}
                            endDate={query.endDate ? new Date(query.endDate) : undefined}
                        />
                        <DatePicker
                            label="End Date"
                            date={query.endDate ? new Date(query.endDate) : undefined}
                            onChange={handleDateChange('endDate')}
                            startDate={query.startDate ? new Date(query.startDate) : undefined}
                        />
                    </div>

                    <div className="flex gap-2 items-center flex-wrap">
                        <CreateDayOff />
                    </div>
                </div>

                {isLoading ? (
                    <div className="flex justify-center items-center h-full">
                        <Loader2 className="animate-spin" />
                    </div>
                ) : (
                    <div className="mt-4 flex flex-wrap gap-4">
                        {
                            data?.map((item) => (
                                <DayOffItem key={item.id} item={item} />
                            ))
                        }
                    </div>
                )}
            </Main>
        </>
    );
};

export default DayOff;